// @flow
import DashboardRoute from "modules/Dashboard/misc/Routes";
import { dashboardRemindersRoute } from "modules/Reminder/Reminders/Routes";
import { ReminderCreationBaseRoute } from "modules/Reminder/Creation/misc/Routes";
import { firstStepRoute } from "modules/ChangeService/Wizard/misc/Paths";
import {
  baseRoute as changeServiceRoute,
  ElectricityRoute,
  GasRoute,
} from "modules/ChangeService/ChangeServices/Routes";
import { baseRoute as topDealsRoute } from "modules/TopDeals/misc/Routes";
import { ContactRoute } from "modules/ContentPages/misc/ContentPageRoutes";
import { FaqBaseRoute } from "modules/FaqPage/misc/Routes";
import { SecondLandingPageRoute } from "modules/DynamicLandingPage/misc/Routes";
import { MyProfileRoute } from "modules/MyProfile/misc/Routes";
import { stromwechselUrl, gaswechselUrl, MyShortOffersBaseRoute } from "modules/MyShortOffers/misc/Routes";
import { RatgeberRoute } from "modules/BlogPages/misc/Routes";
import bonusRoute from "modules/Rewards/misc/Routes";
import FLAVOURS from "../../../flavours/flavours";
import { Environment } from "Commons/Utilities/index";

export type menuItemT = {
  label: string,
  url?: string,
  hide?: string[],
  children?: menuItemT[],
};

const dashboardLabel =
  FLAVOURS[Environment.get(Environment.CLIENT_ID)].name !== FLAVOURS.remindmeApp.name
    ? "Meine Services"
    : "Mein remind.me";

export const navigationItems: menuItemT[] = [
  {
    label: dashboardLabel,
    url: DashboardRoute,
    hide: ["anon"],
  },
  {
    label: "Stromwechsel",
    hide: ["auth"],
    children: [
      {
        label: "Strompreisvergleich",
        url: `${SecondLandingPageRoute}?categoryType=ELECTRICITY`,
      },
      {
        label: "Strom-Wechselservice",
        url: `${ElectricityRoute}/anschluss/erstellen`,
      },
      {
        label: "Gewerbe",
        url: `${ElectricityRoute}/anschluss/erstellen?objectType=company`,
      },
    ],
  },
  {
    label: "Gaswechsel",
    hide: ["auth"],
    children: [
      {
        label: "Gaspreisvergleich",
        url: `${SecondLandingPageRoute}?categoryType=GAS`,
      },
      {
        label: "Gas-Wechselservice",
        url: `${GasRoute}/anschluss/erstellen`,
      },
      {
        label: "Gewerbe",
        url: `${GasRoute}/anschluss/erstellen?objectType=company`,
      },
    ],
  },
  {
    label: "Ratgeber",
    url: RatgeberRoute,
    hide: ["auth", "ratgeber"],
  },
  {
    label: "Wechselservice",
    hide: ["anon"],
    children: [
      {
        label: "Erstellte Wechselservices",
        url: changeServiceRoute,
      },
      {
        label: "Stromwechsel anlegen",
        url: firstStepRoute("strom", true),
      },
      {
        label: "Gaswechsel anlegen",
        url: firstStepRoute("gas", true),
      },
    ],
  },
  {
    label: "Angebote",
    hide: ["anon"],
    children: [
      {
        label: "Angeforderte Angebote",
        url: MyShortOffersBaseRoute,
      },
      {
        label: "Strom-Angebot einholen",
        url: stromwechselUrl,
      },
      {
        label: "Gas-Angebot einholen",
        url: gaswechselUrl,
      },
    ],
  },
  {
    label: "Top-Deals",
    url: topDealsRoute,
    hide: ["topDeals"],
  },
  {
    label: "Erinnerungen",
    hide: ["reminders"],
    children: [
      {
        label: "Erstellte Erinnerungen",
        url: dashboardRemindersRoute,
        hide: ["anon"],
      },
      {
        label: "Erinnerung anlegen",
        url: `${ReminderCreationBaseRoute}/kategorie`,
      },
    ],
  },
  {
    label: "Hilfe",
    children: [
      {
        label: "Fragen & Antworten",
        url: FaqBaseRoute,
      },
      {
        label: "Kontakt",
        url: ContactRoute,
      },
    ],
  },
  {
    label: "profile",
    hide: ["anon"],
    children: [
      {
        label: "Profil",
        url: MyProfileRoute,
      },
      {
        label: "Meine Prämien",
        url: bonusRoute,
      },
      {
        label: "logout",
      },
    ],
  },
];
